<template>
  <!-- OTP 인증 화면입니다 -->
  <div class="text-center">
    <b-card class="d-inline-block" style="width:500px; text-align:center" title="Enter OTP Code">
      <b-card-text>

        <b-form-input  id="input-otp-code" class="d-inline-flex"
                       v-model="otpCode" style="width:200px" placeholder="Enter OTP Code"></b-form-input>

        <br/>
        <b-button @click="checkOtp" class="my-3" variant="primary" size="lg" style="width:200px">Confirm</b-button>
      </b-card-text>
    </b-card>
  </div>

</template>

<script>
import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";
import KTCodePreview from "@/view/content/CodePreview.vue";
import speakEasy from "speakeasy";
import { Auth } from 'aws-amplify';

export default {
  name: "Auth",
  data() {

    return {
      user: null,
      otpCode : "",
    }
  },
  components : {
    KTCodePreview,
  },
  async mounted() {
    let auth = await Auth.currentAuthenticatedUser();
    console.log("auth", auth);

    this.user = auth.attributes;

    await this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Auth" },
    ]);
  },

  methods : {
    async checkOtp(){
      try{
        if(this.user){
          let params = {
            email: this.user.email,
            token: this.otpCode
          };
          let otpVerify = await this.$store.dispatch('otpVerify', params);
          console.log("otpVerify", otpVerify);

          if(otpVerify.statusCode != 200){
            console.log("error");
          }else{
            let otpSecret = otpVerify.otpSecret;
            let otpResult = speakEasy.totp.verify({
              secret: otpSecret,
              encoding: "ascii",
              token: this.otpCode,
              window: 0
            });
            console.log("otpResult", otpResult);
            if(otpResult == true){
              console.log("성공");
            }else{
              console.log("실패")
            }
          }
        }
      }catch (e) {
        console.log("Error in checkOtp", e)
      }
    }
  }
}
</script>

<style scoped>

</style>
